import { Button, message, Modal } from "antd";
import "./style.scss";
import { Uploader } from "../../../components/Upload";
import { useState } from "react";
import { usePostData } from "../../../Network/usePostData";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

type Props = {
  onCloseModal?: () => void;
  loading?: boolean;
  services: any;
};

export const ResultModal = ({ loading, services, onCloseModal }: Props) => {
  const { t } = useTranslation();
  const { requestId } = useParams();

  const [resultsUrls, setResultsUrls] = useState<{ id: number; url: string }[]>(
    [],
  );

  const { mutateAsync, isPending } = usePostData({
    url: "service-request-visit-result",
    options: {
      onSuccess: () => {
        message.success(t("resultModal.resultSentSuccess"));
        onCloseModal?.();
      },
    },
  });

  return (
    <Modal
      width="640px"
      footer={null}
      className="add-result-modal"
      open
      closable={false}
    >
      <h2>{t("resultModal.addResult")}</h2>
      <div className="service-result-wrapper">
        {services?.map((service: any) => (
          <div className="services-result-uploader" key={service.service.id}>
            <div className="service-name">
              <p>{service.service.name.en}</p>
            </div>

            {resultsUrls.find((res) => res.id === service.service.id) ? (
              <div className="logo-view-details">
                <img
                  src={
                    resultsUrls.find((res) => res.id === service.service.id)
                      ?.url
                  }
                  alt="logo-url"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src =
                      "/assets/providers/mokhtabar.png";
                  }}
                />
                <span
                  onClick={() =>
                    setResultsUrls(
                      resultsUrls.filter(
                        (res) => res.id !== service.service.id,
                      ),
                    )
                  }
                  className="update-img-link"
                >
                  {t("resultModal.remove")}
                </span>
              </div>
            ) : (
              <Uploader
                onChange={(url) =>
                  setResultsUrls([
                    ...resultsUrls,
                    { id: service.service.id, url },
                  ])
                }
              />
            )}
          </div>
        ))}
      </div>

      <div className="modal-action">
        <Button
          loading={isPending}
          onClick={async () => {
            try {
              await mutateAsync({
                serviceRequestId: +requestId!!,
                resultsUrls: resultsUrls?.map((res) => {
                  return res.url;
                }),
              });

              message.success(t("resultModal.serviceAdded"));
            } catch (error) {
              message.error(t("resultModal.error"));
            }
          }}
          type="primary"
        >
          {t("resultModal.submit")}
        </Button>
        <Button onClick={onCloseModal} type="default">
          {t("resultModal.cancel")}
        </Button>
      </div>
    </Modal>
  );
};
